import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router';
import { api } from '../../api';

// /q/:codigo — destino do QR colado no equipamento, na via/setor (ficha do agrupador) ou no parque (ficha do cliente)
export function ResolverEtiqueta() {
  const { codigo } = useParams();
  const [destino, setDestino] = useState<string | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  useEffect(() => { api<{ tipo: string; ativo_id?: string; cliente_id: string }>(`/qr/${codigo}`).then((r) => setDestino(r.ativo_id ? `/ativos/${r.ativo_id}` : `/clientes/${r.cliente_id}`)).catch((e) => setErro(e.message)); }, [codigo]);
  if (destino) return <Navigate to={destino} replace />;
  return erro ? <p className="alerta">{erro} (código {codigo})</p> : <p className="nota">Abrindo…</p>;
}
